<template>
  <BreadCrumbs/>
  <MetaPageTitle/>
  <MetaRankingHeaderInfo/>
  <Tabs/>
  <SortBar/>
  <SearchResults>
    <template v-slot:programme_search>
      <ProgrammeSearchResults />
    </template>
    <template v-slot:university_search>
      <UniversitySearchResults />
    </template>
    <template v-slot:scholarship_search>
      <ScholarshipSearchResults />
    </template>
  </SearchResults>
</template>

<script setup lang="ts">
import ProgrammeSearchResults from '@components/SearchResults/ProgrammeSearchResults/ProgrammeSearchResults.vue';
import ScholarshipSearchResults from '@components/SearchResults/ScholarshipSearchResults/ScholarshipSearchResults.vue';
import SearchResults from '@components/SearchResults/SearchResults.vue';
import UniversitySearchResults from '@components/SearchResults/UniversitySearchResults/UniversitySearchResults.vue';
import MetaRankingHeaderInfo from '@components/MetaRankingHeaderInfo/MetaRankingHeaderInfo.vue';
import Tabs from '@components/Tabs/Tabs.vue';
import BreadCrumbs from '@components/Breadcrumbs/Breadcrumbs.vue';
import SortBar from '@components/SortBar/SortBar.vue';
import MetaPageTitle from "@app/components/MetaPageTitle/MetaPageTitle.vue";
</script>
